import { invalidateCachedPageData } from './pageDataCache';
import { persistSessionUser } from './sessionUser';

export function applyCancellationBalances(data) {
  // Discard both the old balance and old receipt list, including when Wallet
  // is unmounted and cannot receive the existing user-updated event.
  invalidateCachedPageData(`wallet:${localStorage.getItem('token') || 'anonymous'}`);
  const user = {};
  if (typeof data.new_wallet_balance === 'number') user.wallet = data.new_wallet_balance;
  if (typeof data.new_points_balance === 'number') user.points = data.new_points_balance;
  if (Object.keys(user).length) persistSessionUser(user);
}

export function cancellationRefundSummary(data) {
  const money = value => Number(value || 0).toFixed(2);
  const lines = [];
  if (Number(data.refunded_wallet) > 0) lines.push(`₹${money(data.refunded_wallet)} refunded to your Instaport wallet. Your refund receipt is available in Wallet → Transactions.`);
  if (Number(data.gateway_refund_amount) > 0) lines.push(`₹${money(data.gateway_refund_amount)} refund requested to your original payment method, not your Instaport wallet. Bank/provider processing time varies.`);
  if (Number(data.charges_deducted_from_refund) > 0) lines.push(`₹${money(data.charges_deducted_from_refund)} cancellation charges withheld from the refund.`);
  if (Number(data.total_wallet_deduction) > 0) lines.push(`₹${money(data.total_wallet_deduction)} deducted from your wallet.`);
  if (Number(data.refunded_points) > 0) lines.push(`${data.refunded_points} points restored.`);
  if (!lines.length) lines.push('Order cancelled. No cancellation charges applied.');
  return lines.join('\n\n');
}
